import React from 'react'
import _ from 'underscore'
import EnquiryLearnersPartial from './partial'

class EnquiryLearners extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.learners !== this.props.learners)
      return true

    if (nextProps.enquiry_id !== this.props.enquiry_id)
      return true

    if (nextProps.subjects !== this.props.subjects)
      return true

    if (nextProps.learner_subjects !== this.props.learner_subjects)
      return true

    if (nextProps.country_code !== this.props.country_code)
      return true

    if (nextProps.customer !== this.props.customer)
      return true

    return false
  }

  render() {
    return (
      <React.Fragment>
        {_.map(this.props.learners, (learner) => {
          const learner_subjects = _.select(this.props.learner_subjects, (learner_subject) => {
            return (
              (learner_subject.enquiry_learner_id === learner.id) && _.any(this.props.subjects, function(subject) {return subject.id === learner_subject.enquiry_subject_id})
            )
          })

          return (
            <EnquiryLearnersPartial
              key={learner.id}
              learner={learner}
              enquiry_id={this.props.enquiry_id}
              subjects={this.props.subjects}
              learner_subjects={learner_subjects}
              country_code={this.props.country_code}
              customer={this.props.customer}
            />
          )
        })}
      </React.Fragment>
    )
  }
}

export default EnquiryLearners
